import { useReducer } from "react";

export type ModalHandler = {
  modal: number;
  close: number;
  executeModal: () => void;
  executeClose: () => void;
};

export function useExecuteModal(): ModalHandler {
  const [modal, executeModal] = useReducer((state: number): number => {
    return state + 1;
  }, 0);

  const [close, executeClose] = useReducer((state: number): number => {
    return state + 1;
  }, 0);

  return { modal, executeModal, close, executeClose };
}
